import { Numbers } from '@/components/team-management/numbers/numbers';
import { Layout } from '@/components/ui/design-system';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/settings/numbers/')({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>): { action?: string } => {
    return {
      action: typeof search.action === 'string' && search.action ? search.action : undefined,
    };
  },
});

function RouteComponent() {
  const search = Route.useSearch();

  return (
    <Layout isScrollable contentClassName="max-w-[960px] px-20 !pt-0 pb-30">
      <Numbers initialAction={search.action} />
    </Layout>
  );
}
